export const financial = {
	title: "Daily Extract",
	filename: "daily-extract",
	details: "see details",
	noDataToShow: "There is nothing to show for the selected period",
	table: {
		datetime: "Date",
		in: "Entry",
		out: "Exit",
		balance: "Balance",
		withdrew: "Withdrew",
		total: "Total",
	},
	summaryTitle: "Summary for {{date}}",
	event: "Events",
	noResume: "There is no closing in the period",
	modality: "Modality",
	payvalue: "Payable/Receivable",
	receive: "Receivable",
	pay: "Payable",
};
